export default "__VITE_ASSET__URZ6c3H9__"